var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuLexis = function SvgMenuLexis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 4.853V23c1.658-.158 3.125-.183 4.53-.947l3.813-2.072c1.2-.653 1.657-1.776 1.657-2.863V6.529c0-2.78-4.129-4.516-7.197-2.848-.893.485-1.756 1.03-2.803 1.172M12.5 23c-1.66-.158-2.868-.183-4.276-.947L4.408 19.98C3.207 19.329 2.5 18.306 2.5 17.218V6.38c0-2.78 4.383-4.366 7.454-2.698.894.485 1.498 1.03 2.546 1.172z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#menu-lexis_svg__a)",
    d: "M12.5 4.863h1V23h-1z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "menu-lexis_svg__a",
    x1: 13.008,
    x2: 15.707,
    y1: 26.864,
    y2: 26.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};
export { SvgMenuLexis as ReactComponent };